import { __RouterContext } from 'react-router-dom';
import { useContext } from 'react';

const useHistory = () => {
  const { history } = useContext(__RouterContext);
  return history;
};

export default useHistory;
